import React from 'react';
import PropTypes from 'prop-types';

import LogoutButton from './LogoutButton';

const LogoutUserSessions = ({ logout, clicked, children, text }) => (
  typeof children === 'function'
    ? children({ logout, clicked, text })
    : React.cloneElement(children, { logout, clicked, text })
);

LogoutUserSessions.propTypes = {
  text: PropTypes.string,
  logout: PropTypes.func.isRequired,
  clicked: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
};

LogoutUserSessions.defaultProps = {
  children: LogoutButton,
  text: 'Logout all sessions',
};

export default LogoutUserSessions;
